export default "__VITE_ASSET__BYRHJfPc__"